import { useEffect, useState } from 'react'
import { useUser } from '@fs/zion-user'
import getPermission from '@fs/zion-permissions'

export default function usePermission(context, permission) {
  const { signedIn, userLoading } = useUser()
  const [loading, setLoading] = useState(true)
  const [hasPermission, setHasPermission] = useState(false)

  useEffect(() => {
    const checkPermission = async () => {
      const { authorized } = await getPermission(permission, context)
      // console.log({ authorized, context, permission })
      setHasPermission(authorized)
      setLoading(false)
      return authorized
    }

    if (signedIn && !userLoading) {
      checkPermission()
    }
  }, [context, permission, signedIn, userLoading])
  // console.log('loading', loading)
  // console.log('hasPermission', hasPermission)
  return { loading, hasPermission }
}

export const usePrisonReportsPermission = () => {
  return usePermission('GetInvolvedCorrectionalContext', 'GetInvolvedViewFacilityStats')
}
